import {create} from "zustand";

import type {HouseholdAssistCandidate} from "../types/household-assist";

type DispatchDeskHouseholdMatchState = {
  match: HouseholdAssistCandidate | null;
  setMatch: (match: HouseholdAssistCandidate | null) => void;
  clearMatch: () => void;
};

export const useDispatchDeskHouseholdMatchStore = create<DispatchDeskHouseholdMatchState>(
  (set) => ({
    match: null,
    setMatch: (match) => set({match}),
    clearMatch: () => set({match: null}),
  }),
);

export function useDispatchDeskHouseholdMatch() {
  return useDispatchDeskHouseholdMatchStore((state) => state.match);
}
